import { urlDefaultAux, controlador, empresa } from "../../../constants/urls";

// Catálogos reutilizados
export const urlListarMarcas = `${urlDefaultAux}${controlador}marcas/listar-marcas-aig${empresa}`;
export const urlListarColores = `${urlDefaultAux}${controlador}site/listar-colores-aig${empresa}`;
export const urlListarModelos = `${urlDefaultAux}${controlador}modelos/listar-modelos-aig${empresa}&marca=`;

// CRUD Vehículos (Backend REST API con verbos correctos)
export const urlListarAutos = `${urlDefaultAux}${controlador}autos-test/listar${empresa}`;
export const urlCrearAuto = `${urlDefaultAux}${controlador}autos-test/crear`;
export const urlEditarAuto = `${urlDefaultAux}${controlador}autos-test/editar&id=`;
export const urlEliminarAuto = `${urlDefaultAux}${controlador}autos-test/eliminar&id=`;
